import { LEARNER_ASSIGNMENT_QUERY_KEY } from "./learnerAssignmentQueryKeys";
import { LearnerAssignmentStatus } from "../../types";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { OneOrManyFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { ILearnerAssignmentList } from "../types";

export interface ILearnerAssignmentListQueryParameters extends IPaginateable, IOrderable<"assignedAt"> {
    filters?: {
        /** Keeps only the given statuses. The API orders the list, the client never sorts it. */
        learnerAssignmentStatus?: OneOrManyFilter<LearnerAssignmentStatus>;
        /** Uuid of the only classroom to read. An unknown one matches nothing rather than everything. */
        classroom?: string;
    };
}

export type ILearnerAssignmentListQueryResult = ILearnerAssignmentList;

export const learnerAssignmentListQuery: IApiQueryFunction<ILearnerAssignmentListQueryParameters> = ({
    filters,
    order,
    pagination,
}) => ({
    method: "GET",
    url: `/learner_assignments${serialize(
        {
            ...mapPagination(pagination),
            ...mapOrder(order),
            learnerAssignmentStatus: filters?.learnerAssignmentStatus,
            classroom: filters?.classroom,
        },
        true,
    )}`,
});

const useQuery = createApiQueryHook<ILearnerAssignmentListQueryParameters, ILearnerAssignmentListQueryResult>(
    learnerAssignmentListQuery,
);

export const useLearnerAssignmentListQuery = (
    parameters: ILearnerAssignmentListQueryParameters,
    options: Omit<NonNullable<Parameters<typeof useQuery>[1]>, "queryKey"> = {},
) => useQuery(parameters, { ...options, queryKey: [LEARNER_ASSIGNMENT_QUERY_KEY, "list", parameters] });
